export default __webpack_public_path__ + "static/media/background.c70e7440.webm";